import axios from "axios";
import definedApi from "./definedApi";
import appConfig from "../config/appConfig";
import { parseDecryptedValue } from "../pages/authentication/EncryptAuth";
import proModuleLicensingConfig from "./moduleLicensingProd.json";
import devModuleLicensingConfig from "./moduleLicensingDev.json";

const moduleLicensingConfig = appConfig.isProduction
  ? proModuleLicensingConfig
  : devModuleLicensingConfig;

export const parsePermissions = (permissions) => {
  if (!permissions) return [];
  if (Array.isArray(permissions)) return permissions;
  try {
    return JSON.parse(atob(permissions));
  } catch (error) {
    try {
      const parsedPermissions = JSON.parse(permissions);
      console.log(parsedPermissions, "parsedPermissions");
      return parsedPermissions;
    } catch (innerError) {
      return [];
    }
  }
};

/** Map login or /session payload into Redux userData shape. */
export const normalizeAuthUser = (res = {}) => {
  const permissions = parsePermissions(res.permissions);
  let flags = {};

  if (res?.authenticationToken) {
    try {
      flags = parseDecryptedValue(atob(res.authenticationToken)) || {};
    } catch (error) {
      flags = {};
    }
  }

  return {
    ...res,
    // Cookie carries identity; keep a truthy marker for legacy checks.
    session: res.session || "cookie",
    permissions,
    licensingConfig: res.licensingConfig || moduleLicensingConfig,
    isTwoFactorAuthenticationRequired:
      flags.isTwoFactorAuthenticationRequired ?? res.isTwoFactorAuthenticationRequired ?? false,
    shouldRenewPassword: flags.shouldRenewPassword ?? res.shouldRenewPassword ?? false,
  };
};

export const fetchSession = async () => {
  const response = await axios.get(definedApi.Refresh, {
    withCredentials: true,
  });
  return response?.data;
};

/** Rotate the auth cookies via GET /refresh. */
export const refreshSession = fetchSession;

export const logoutSession = async () => {
  try {
    await axios.post(
      definedApi.Logout,
      {},
      {
        withCredentials: true,
      },
    );
  } catch (error) {
    // Still clear local auth even if logout API fails.
    console.warn("Logout API failed:", error?.message || error);
  }
};
